import { computed, onMounted, onUnmounted, ref, watch, type Ref } from 'vue'

interface UseNewOrderModalUiStateOptions {
  isPosOnlyMode: Ref<boolean>
  modeLoaded: Ref<boolean>
  t: (key: string) => string
}

export function useNewOrderModalUiState(options: UseNewOrderModalUiStateOptions) {
  const activeTab = ref(0)
  const isMobile = ref(false)

  const availableTabs = computed(() => {
    const allTabs = [
      options.t('app.views.orders.modals.new_order.tabs.order_info'),
      options.t('app.views.orders.modals.new_order.tabs.menu_items'),
      options.t('app.views.orders.modals.new_order.tabs.summary')
    ]

    if (options.modeLoaded.value && options.isPosOnlyMode.value) {
      return allTabs.slice(1)
    }

    return allTabs
  })

  watch(
    [options.isPosOnlyMode, options.modeLoaded],
    ([isPOS, loaded]) => {
      if (loaded && isPOS && activeTab.value === 0) {
        activeTab.value = 1
      }
    },
    { immediate: true }
  )

  const checkMobile = () => {
    isMobile.value = window.innerWidth < 768
  }

  onMounted(() => {
    checkMobile()
    window.addEventListener('resize', checkMobile)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', checkMobile)
  })

  return {
    activeTab,
    availableTabs,
    isMobile
  }
}
